import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImageUrls: Record<string, string> = {
  'access-tutorial': 'https://readdy.ai/api/search-image?query=Abstract%20digital%20navigation%20compass%20on%20dark%20background%2C%20warm%20green%20glowing%20pathways%2C%20minimalist%20tech%20concept%2C%20clean%20modern%20design%20with%20geometric%20elements&width=800&height=500&seq=cat-access&orientation=landscape',
  'security-guide': 'https://readdy.ai/api/search-image?query=Digital%20shield%20and%20lock%20symbols%20with%20protective%20energy%20field%2C%20warm%20amber%20glow%2C%20cybersecurity%20concept%2C%20minimalist%20abstract%20design&width=800&height=500&seq=cat-security&orientation=landscape',
  'privacy-protection': 'https://readdy.ai/api/search-image?query=Invisible%20digital%20cloak%20protecting%20data%20streams%2C%20warm%20green%20and%20amber%20accents%2C%20privacy%20concept%2C%20minimalist%20abstract%20art&width=800&height=500&seq=cat-privacy&orientation=landscape',
  'in-depth-review': 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20digital%20data%20grid%2C%20analytical%20review%20concept%2C%20warm%20amber%20highlights%2C%20modern%20minimalist%20design&width=800&height=500&seq=cat-review&orientation=landscape',
  'latest-news': 'https://readdy.ai/api/search-image?query=Digital%20newspaper%20with%20glowing%20headlines%20emerging%20from%20dark%20background%2C%20warm%20green%20accents%2C%20modern%20news%20concept%2C%20minimalist%20design&width=800&height=500&seq=cat-news&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按照主题浏览我们精心整理的暗网安全知识库
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg h-56"
            >
              <img
                src={categoryImageUrls[cat.slug] || ''}
                alt={cat.name}
                title={`${cat.name} - ${cat.description}`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm">
                    <i className={`${cat.icon} text-white text-base`}></i>
                  </span>
                  <span className="text-white/80 text-xs">{cat.articleCount}篇文章</span>
                </div>
                <h3 className="text-lg font-heading font-semibold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/70 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}